<template>
  <div>
    <form @submit.prevent="submit">
      <h4>{{ $t("global.import-ssl-form-desc") }}</h4>
      <div class="ssl-details">
        <FormTextArea
          name="key"
          v-model="fields.key"
          :label="$t('global.private-key')"
          :placeholder="$t('global.begin-private-key')"
          :errors="validation.fields.key.errors"
          :dirty="validation.fields.key.dirty"
          :rows="10"
        />
        <FormTextArea
          name="crt"
          v-model="fields.crt"
          :label="$t('global.certificate')"
          :placeholder="$t('global.begin-csr')"
          :errors="validation.fields.crt.errors"
          :dirty="validation.fields.crt.dirty"
          :rows="10"
        />
        <FormTextArea
          name="chain_crts"
          v-model="fields.chain_crts"
          :label="$t('global.chain-certificates')"
          :placeholder="$t('global.begin-csr')"
          :errors="validation.fields.chain_crts.errors"
          :dirty="validation.fields.chain_crts.dirty"
          :rows="10"
        />
      </div>
      <div class="form-buttons">
        <Btn class="mr-2" variant="light" type="button" @click="cancel">
          {{ $t("global.cancel") }}
        </Btn>
        <Btn variant="primary" type="submit" :loading="loading">
          {{ $t("global.import") }}
        </Btn>
      </div>
    </form>
  </div>
</template>
<script>
import { reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import FormTextArea from "@/components/display/form/FormTextArea";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { importSsl as validationRules } from "leatherman-js/utils/validations/forms";

export default {
  name: "CertificateImportForm",
  components: {
    Btn,
    FormTextArea,
  },
  setup(props, { emit, root }) {
    const loading = ref(false);
    const errors = ref(null);
    const fields = reactive({
      key: "",
      crt: "",
      chain_crts: "",
    });

    const cancel = () => emit("close");
    const { validator } = useValidator();
    const validation = validator(
      fields,
      validationRules,
      {},
      {
        crt: {
          required: root.$t("validation.certificate-required"),
        },
        key: {
          required: root.$t("validation.certificate-key-required"),
        },
      }
    );

    const submit = () => {
      errors.value = null;
      validation
        .validate()
        .then(() => {
          loading.value = true;
          store
            .dispatch("certificates/addCert", { ...fields })
            .then(() => {
              store.dispatch("toasts/addToast", {
                variant: "info",
                message: root.$t("toasts.ssl-importing-message"),
              });
              emit("close");
            })
            .catch((e) => {
              const errors = e.request.response;
              for (let key in errors) {
                let message = errors[key];
                if (message.length > 0) {
                  store.dispatch("toasts/addToast", {
                    variant: "error",
                    message: root.$t("toasts.ssl-import-error-message", { error: message }),
                  });
                } else {
                  store.dispatch("toasts/addToast", {
                    variant: "error",
                    message: root.$t("toasts.ssl-import-error-message", { error: "" }),
                  });
                }
              }
            })
            .finally(() => {
              loading.value = false;
            });
        })
        .catch(() => {});
    };

    return {
      cancel,
      errors,
      fields,
      loading,
      submit,
      validation,
    };
  },
};
</script>
<style lang="scss" scoped>
.ssl-package {
  width: 50%;
  display: inline-block;
}
</style>
